import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk';
import * as AWS_IoT from 'aws-iot-device-sdk';

import { MQTTService } from '../services/mqtt.service';

import { environment } from '../../environments/environment';
import { AuthenticationService } from './authentication.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SET_MAIN_VIEW, CLEAR_TASKS, _CLEAR } from 'ngrx/actions';
import { Subject } from 'rxjs';

@Injectable()
export class CredentialService {
  AWS            : any;
  AWS_IoT        : any;
  cognitoIdentity: AWS.CognitoIdentity;
    creds          : AWS.CognitoIdentityCredentials;
  device         : any;
  lambda         : AWS.Lambda;
  s3             : AWS.S3;
  user           : any;
  logoutTrigger      : Subject<any> = new Subject();
  

  constructor(
    private mqttService: MQTTService,
    private router           : Router,
    private store            : Store<any>
  ) {
    this.AWS     = AWS;
    this.AWS_IoT = AWS_IoT;
  }

  initialize() {
    this.establishCredentials();
  }

  clearCredentials(): void {
    if (this.creds) {
      this.creds.params['IdentityId'] = null;
      this.creds.params['Logins'] = null;
      this.creds.clearCachedId();
      this.creds.refreshPromise();
    }
  }

  subscribeToMessages(retryCount, maxRetry): void{
    //console.log("retrycount", retryCount)
    //console.log("maxRetry", maxRetry)
    let mqttRetryCount = Number(localStorage.getItem('mqttRetry'));
    console.log('mqttRetryCount', mqttRetryCount)
    this.mqttService
      .AWSIoTConnect(this.getCredentials(), retryCount)
      .subscribe(
        (value: any) => console.log(value),
        (error: Error) => {
          console.log(error);
          if(mqttRetryCount < maxRetry){
            retryCount++;
            console.log(`Trying to reset MQTT Subscriptions Retry Count CREDENTIAL SERVICE : ${retryCount}`);
            if(retryCount > 0){ 
              let mqttRetryCount = Number(localStorage.getItem('mqttRetry'));
              mqttRetryCount++;
              localStorage.setItem('mqttRetry', String(mqttRetryCount));
              window.location.reload(); 
            }
            setTimeout(()=> { this.subscribeToMessages(retryCount,maxRetry) }, 40000);
          } else {        
            console.log("MQTT Expired logging out...")
            this.store.dispatch({
              type: SET_MAIN_VIEW,
              payload: { loggingOut: true }
            });
            setTimeout(() => {
                localStorage.removeItem('currentUser');
                localStorage.removeItem('mqttRetry');
                this.router.navigate(['/pages/login']);
                this.logoutTrigger.next();
                this.mqttService.disconnectIoT("mqtt disconnect from credentialService");
                this.clearCredentials();
    
                this.store.dispatch({ type: CLEAR_TASKS });
                this.store.dispatch({ type: _CLEAR });
                // location.reload();
            }, 1000);

            console.log(`CAN NOT SUBSCRIBE TO MQTT CHANNELS`);
          }
        }
      );
  }

  establishCredentials(): void {
    this.clearCredentials();

    if (this.AWS.config.credentials) {
      (<any>this.AWS.config.credentials).clearCachedId();
    }

    this.creds = new this.AWS.CognitoIdentityCredentials({
      IdentityPoolId: environment.identityPoolId
    });

    try {
      const userData = localStorage.getItem('currentUser');
      this.user = JSON.parse(userData);
    } catch (err) {
      console.log('local storage is not supported');
      this.user = null;
    }

    if (this.user) {
      this.setCredentials(this.user);
    }

    this.AWS.config.update({
      region: environment.region,
      credentials: this.creds
    });

    this.cognitoIdentity = new this.AWS.CognitoIdentity({ region: 'us-east-1' });
    this.lambda = new this.AWS.Lambda({ region: 'us-east-1' });
    this.s3 = new this.AWS.S3({ apiVersion: '2006-03-01' });


    if (this.user) {
      this.subscribeToMessages(0,5);
    }
  }

  getCredentials(): any {
    return {
      AWS: this.AWS,
      AWS_IoT: this.AWS_IoT,
      cognitoIdentity: this.cognitoIdentity,
      creds: this.creds
    };
  }

  setCredentials(credentials): void {
    const { identityId, token } = credentials;

    this.creds.params['IdentityId'] = identityId;
    this.creds.params['Logins'] = {
      'cognito-identity.amazonaws.com': token
    };
    this.creds.expired = true;
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/services/credential.service.ts